//FROMCDN
await themeComponent(theme.components['mc-element'], false);
await themeResource(theme.resources['mc-utils'], false);
await themeResource(theme.resources['mc-shopify'], false);
await themeComponent(theme.components['mc-form-errors'], false);
await themeComponent(theme.components['mc-input'], false);

class McForm extends McElement {
  form; inputs; isValid; buttons; data; options; errors;

  connectedCallback() {
    this.init();
  }

  init = () => {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.inputs = this.querySelectorAll('mc-input-text, mc-input-checkbox, mc-input-select, mc-input-area, mc-input-checkbox-group, mc-input-password');
    this.inputs.forEach(input => {
      const realInput = input.querySelector('input, textarea, select');

      if (realInput) {
        realInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();

            // Optional: manually trigger your submit here
            if (realInput.type !== 'textarea') {
            this.submit();
          }
        }
      });
     }
    });

    this.buttons = this.querySelectorAll('[data-submit]');
    this.errors = this.querySelector('mc-form-errors');

    // Always prevent native form submit (Enter key, etc)
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit(); // Use our controlled logic
    });

    // Ensure we have a fallback submit button for Enter key behavior
    if (!this.form.querySelector('[type="submit"]')) {
      const hiddenSubmit = document.createElement('button');
      hiddenSubmit.type = 'submit';
      hiddenSubmit.style.display = 'none';
      hiddenSubmit.ariaHidden = 'true';
      this.form.appendChild(hiddenSubmit);
    }

    this.handleButtons();
  }

  handleButtons = () => {
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.submit();
      });
    });
  }

  validate = () => {
    this.isValid = true;
    this.inputs.forEach(input => {
      input.validate?.(); // Call validate if it's defined
      if (typeof input.isValid !== 'undefined') {
        this.isValid = this.isValid && input.isValid;
      }
    });
    McShopify.customEvent(MCEVENTS.FORM_VALIDATE, this.isValid, this);
  }

  submit = () => {
    this.validate();

    if (!this.isValid) {
      console.warn('McForm: Form invalid, submission blocked.');
      return;
    }

    McShopify.customEvent(MCEVENTS.FORM_SUBMIT, null, this);

    if (this.dataset.ajax !== undefined) {
      this.getData();
      this.getOptions();
      this.ajaxSubmit();
    } else {
      this.form.requestSubmit(); // This only happens if valid
    }
  }

  ajaxSubmit = () => {
    axios(this.options)
      .then(this.success.bind(this))
      .catch(this.error.bind(this))
      .finally(this.complete.bind(this));
  }

  getData = () => {
    const formData = new FormData(this.form);

    if (this.dataset.contentType?.includes('json')) {
      this.data = JSON.stringify(McForm.formDataToObject(formData));
    } else if (this.dataset.contentType?.includes('form')) {
      this.data = formData;
    } else {
      this.data = new URLSearchParams(formData);
    }
  }

  getOptions = () => {
    const headers = {};
    const method = this.form.method || 'POST';

    if (this.dataset.contentType) {
      headers['Content-Type'] = this.dataset.contentType;
    }
    if (this.dataset.authUser && this.dataset.authToken) {
      headers['Authorization'] = 'Basic ' + btoa(`${this.dataset.authUser}:${this.dataset.authToken}`);
    }

    this.options = {
      url: this.form.action,
      method,
      headers
    };

    if (method.toUpperCase() === 'GET') {
      this.options.params = this.data;
    } else {
      this.options.data = this.data;
    }
  }

  error = (e) => {
    McShopify.customEvent(MCEVENTS.FORM_ERROR, e, this);
    console.error(e);
    this.errors?.showError(e.message || theme.t.errors.generic);
  }

  success = (response) => {
    McShopify.customEvent(MCEVENTS.FORM_SUCCESS, response, this);
    this.errors?.clear();
  }

  complete = () => {
    McShopify.customEvent(MCEVENTS.FORM_COMPLETED, null, this);
  }

  static formDataToObject = (formData) => {
    const object = {};
    formData.forEach((value, key) => {
      if (value === 'true') value = true;
      else if (value === 'false') value = false;
      else if (value === 'null') value = null;

      const arrayKeyMatch = key.match(/(\w+)\[(\d*)\]\[(\w+)\]/);

      if (arrayKeyMatch) {
        const [_, arrayKey, index, subKey] = arrayKeyMatch;
        if (!object[arrayKey]) object[arrayKey] = [];
        if (index) {
          if (!object[arrayKey][index]) object[arrayKey][index] = {};
          object[arrayKey][index][subKey] = value;
        } else {
          const newItem = {};
          newItem[subKey] = value;
          object[arrayKey].push(newItem);
        }
      } else if (key.endsWith('[]')) {
        const keyName = key.slice(0, -2);
        if (!Array.isArray(object[keyName])) object[keyName] = [];
        try {
          object[keyName].push(JSON.parse(value));
        } catch {
          object[keyName].push(value);
        }
      } else {
        const keys = key.split('.');
        keys.reduce((acc, k, i) => {
          if (i === keys.length - 1) acc[k] = value;
          else acc[k] = acc[k] || {};
          return acc[k];
        }, object);
      }
    });

    return object;
  }
}

// Register the custom element if not already defined
if (!customElements.get('mc-form')) {
  customElements.define('mc-form', McForm);
}

window.McForm = McForm;
export default McForm;
